import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GenerateReportRequest = (siteId, reportType, reportVendor, activationDate, userId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}RanReportKpis/GenerateReport`,
	data: { siteId, reportType, reportVendor, activationDate, userId }
});
